export const REQUIRED_MESSAGE = 'Please supply a value.';
export const INVALID_SSN_FORMAT = 'Please enter a complete social security number.';
export const INVALID_PHONE_FORMAT = 'Please enter a complete phone number.';
export const INVALID_ZIP_FORMAT = 'Please enter a complete zip code.';
export const INVALID_EMAIL_FORMAT = 'Please enter a complete email address.';
export const INVALID_DATE = 'Please enter a valid date';
export const INVALID_HEIGHT = 'Please enter a valid height';
export const INVALID_POLICY_NUMBER = 'Please enter a valid policy number.';
export const INVALID_PERCENTAGE = 'Please enter a valid percentage. Total percentage should be less than 100%';
export const INVALID_CASE_NUMBER = 'Please enter a valid case number.';
export const DUPLICATE_AGENT = 'No Duplicate Agent are allowed.';
